import { render, staticRenderFns } from "./_template.html?vue&type=template&id=485acb23&external"
import script from "./_logic.ts?vue&type=script&lang=ts&external"
export * from "./_logic.ts?vue&type=script&lang=ts&external"
import style0 from "./_styles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports